export const prepareReceivedWidgetData = receivedData => {
  if (!receivedData) {
    return {
      color: '',
      coverPhoto: {
        image: ''
      },
      languages: [],
      selectedUnitId: '',
      privacyPolicy: '',
      termsAndConditions: ''
    };
  }

  const languages = [...receivedData.languages].map(item => {
    if (item === 'Norway') {
      return 'Norwegian';
    }
    return item;
  });

  return {
    coverPhoto: { image: receivedData.photo },
    color: receivedData.color,
    id: receivedData.id,
    languages: receivedData.languages ? languages : [],
    privacyPolicy: receivedData.privacyPolicy,
    termsAndConditions: receivedData.termsAndConditions
  };
};

export const prepareUnitsDataForSelect = data => {
  const accommodations = [];
  const activities = [];
  const rentalItems =[];
  if (!data) {
    return {};
  }

  data.accommodations.forEach(accommodation => {
    accommodations.push({
      value: accommodation.id,
      label: accommodation.title
    });
  });

  data.activities.forEach(activity => {
    activities.push({
      value: activity.id,
      label: activity.title
    });
  });
  data.rentalItems
  .filter(rental => rental?.status?.id === 1)
  .forEach(rental => {
    rentalItems.push({
      value: rental.id,
      label: rental.title
    });
  });
  return {
    accommodations: accommodations,
    activities: activities,
    rentalItems: rentalItems
  };
};
